import React, { Fragment } from 'react';
import { useRouteMatch } from 'react-router-dom';

import { PlatformMerchantOrderWithOrderItemsDetails, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { MerchantNavigation } from '../../navigation/MerchantNavigation';

interface IProps {
  party: any;
}

const PlatformMerchantOrderDetails: React.FC<IProps> = ({ party }: IProps) => {
  const { orderId } = MerchantNavigation.platformMerchantOrderDetails.paramsFromPath(useRouteMatch());
  const { data: orderData, loading: orderLoading } = GQLOperationBuilder.merchant.getPlatformMerchantOrder({
    orderId: orderId
  });

  if (orderLoading) return <LoadingSpinner />;

  const order = GQLOperationBuilder.merchant.platformMerchantOrderFromResponse(orderData);

  return (
    <Fragment>
      <PlatformMerchantOrderWithOrderItemsDetails order={order} />
    </Fragment>
  );
};

export default PlatformMerchantOrderDetails;
